"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleNetworkContractStore = void 0;
var erc20_json_1 = __importDefault(require("../default-abis/erc20.json"));
var erc721_json_1 = __importDefault(require("../default-abis/erc721.json"));
var erc1155_json_1 = __importDefault(require("../default-abis/erc1155.json"));
/**
 * Static Contract Store for managing ABIs and deployments on a single network
 */
var SingleNetworkContractStore = /** @class */ (function () {
    function SingleNetworkContractStore(chainId, config, opts) {
        var _this = this;
        this.chainId = chainId;
        var abis = {};
        if (!(opts === null || opts === void 0 ? void 0 : opts.withoutDefaultABIs)) {
            abis["ERC20"] = erc20_json_1.default;
            abis["ERC721"] = erc721_json_1.default;
            abis["ERC1155"] = erc1155_json_1.default;
        }
        if (config.abis) {
            Object.entries(config.abis).forEach(function (_a) {
                var key = _a[0], abi = _a[1];
                abis[key] = abi;
            });
        }
        this.abis = abis;
        var deployments = {};
        if (config.deployments) {
            Object.entries(config.deployments).forEach(function (_a) {
                var key = _a[0], deployment = _a[1];
                if (!_this.abis[deployment.abiKey]) {
                    throw new Error("No ABI for key ".concat(deployment.abiKey, " and chain ID ").concat(_this.chainId, " has been found."));
                }
                deployments[key] = deployment;
            });
        }
        this.deployments = deployments;
    }
    /**
     * Get an ABI
     * @param key String key of the ABI
     * @returns The ABI
     */
    SingleNetworkContractStore.prototype.getAbi = function (key) {
        var abi = this.abis[key];
        if (!abi) {
            throw new Error("No ABI for key ".concat(String(key), " and chain ID ").concat(this.chainId, " has been found."));
        }
        return abi;
    };
    /**
     * Get a contract by finding the address and ABI
     * @param key String key of the deployment of the contract
     * @returns The address and ABI of the contract
     */
    SingleNetworkContractStore.prototype.getContract = function (key) {
        var deployment = this.getDeployment(key);
        var abi = this.getAbi(deployment.abiKey);
        return {
            address: deployment.address,
            abi: abi,
        };
    };
    /**
     * Get an address
     * @param key String key of the deployment
     * @returns The address of the deployment
     */
    SingleNetworkContractStore.prototype.getAddress = function (key) {
        var deployment = this.getDeployment(key);
        return deployment.address;
    };
    /**
     * Get all the addresses
     * @returns The array of addresses
     */
    SingleNetworkContractStore.prototype.getAddresses = function () {
        return Object.values(this.deployments).map(function (deployment) { return deployment.address; });
    };
    /**
     * Convert the store to an object
     * @returns The store abis and deployments
     */
    SingleNetworkContractStore.prototype.toObject = function () {
        return {
            abis: this.abis,
            deployments: this.deployments,
        };
    };
    /**
     * Get a deployment
     * @param key String key of the deployment
     * @returns The deployment
     */
    SingleNetworkContractStore.prototype.getDeployment = function (key) {
        var deployment = this.deployments[key];
        if (!deployment) {
            throw new Error("No deployment for key ".concat(String(key), " and chain ID ").concat(this.chainId, " has been found."));
        }
        return deployment;
    };
    return SingleNetworkContractStore;
}());
exports.SingleNetworkContractStore = SingleNetworkContractStore;
